<form #alternativeRoutingSipReasonsDialog="ngForm" autocomplete="off">
  <mat-form-field class="fullWidth">
    <mat-label>SIP Response</mat-label>
    <input matInput [(ngModel)]="sipReason.sipResponseNumber" type="number" min="1"
           max="2147483647" name="sipResponseNumber" required>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Description</mat-label>
    <input matInput [(ngModel)]="sipReason.sipResponseDescription" maxlength="255" name="name">
  </mat-form-field>

  <mat-checkbox name="reroute" color="primary" [(ngModel)]="sipReason.reroute">Active</mat-checkbox>
</form>
